/* unplugin-vue-components disabled */import { render } from "./OralTest.vue?vue&type=template&id=11c024ab&scoped=true"
import script from "./OralTest.vue?vue&type=script&lang=js"
export * from "./OralTest.vue?vue&type=script&lang=js"

import "./OralTest.vue?vue&type=style&index=0&id=11c024ab&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c024ab"]])

export default __exports__